import {
  SMVM_GET_ASPECT_GUIDE_FAIL,
  SMVM_GET_ASPECT_GUIDE_REQUEST,
  SMVM_GET_ASPECT_GUIDE_RESET,
  SMVM_GET_ASPECT_GUIDE_SUCCESS,
  SMVM_GET_ASSESSEE_GUIDE_FAIL,
  SMVM_GET_ASSESSEE_GUIDE_REQUEST,
  SMVM_GET_ASSESSEE_GUIDE_RESET,
  SMVM_GET_ASSESSEE_GUIDE_SUCCESS,
  SMVM_GET_ASSESSOR_GUIDE_FAIL,
  SMVM_GET_ASSESSOR_GUIDE_REQUEST,
  SMVM_GET_ASSESSOR_GUIDE_RESET,
  SMVM_GET_ASSESSOR_GUIDE_SUCCESS,
} from "../constants/GuideConstants";

export const smvm_get_assessor_guide_reducers = (
  state = { data: {} },
  action
) => {
  switch (action.type) {
    case SMVM_GET_ASSESSOR_GUIDE_REQUEST:
      return { loading: true };
    case SMVM_GET_ASSESSOR_GUIDE_SUCCESS:
      return { loading: false, data: action.payload, success: true };
    case SMVM_GET_ASSESSOR_GUIDE_FAIL:
      return { loading: false, error: action.payload };
    case SMVM_GET_ASSESSOR_GUIDE_RESET:
      return {};
    default:
      return state;
  }
};

export const smvm_get_assessee_guide_reducers = (
  state = { data: {} },
  action
) => {
  switch (action.type) {
    case SMVM_GET_ASSESSEE_GUIDE_REQUEST:
      return { loading: true };
    case SMVM_GET_ASSESSEE_GUIDE_SUCCESS:
      return { loading: false, data: action.payload, success: true };
    case SMVM_GET_ASSESSEE_GUIDE_FAIL:
      return { loading: false, error: action.payload };
    case SMVM_GET_ASSESSEE_GUIDE_RESET:
      return {};
    default:
      return state;
  }
};

export const smvm_get_aspect_guide_reducers = (
  state = { data: {} },
  action
) => {
  switch (action.type) {
    case SMVM_GET_ASPECT_GUIDE_REQUEST:
      return { loading: true };
    case SMVM_GET_ASPECT_GUIDE_SUCCESS:
      return { loading: false, data: action.payload, success: true };
    case SMVM_GET_ASPECT_GUIDE_FAIL:
      return { loading: false, error: action.payload };
    case SMVM_GET_ASPECT_GUIDE_RESET:
      return {};
    default:
      return state;
  }
};
